{
    "button": "Paramètres",
    "group_my_account": "Mon compte",
    "group_organisation": "Organisation",
    "language_label": "Langue",
    "default_metric_label": "Indicateur",
    "default_metric_description": "L'indicateur affiché par défaut dans Plato.",
    "metric_revenue": "Chiffre d'affaires",
    "metric_order_sum": "Montant des commandes",
    "default_timeframe_label": "Période",
    "default_timeframe_description": "La période affichée par défaut dans Plato.",
    "timeframe_ytd": "Année en cours",
    "timeframe_ttm": "12 derniers mois"
}
